import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-j-message-article-panel__body" }
const _hoisted_2 = { class: "p-j-message-article-panel__icon" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "p-j-message-article-panel__point"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconUserImage = _resolveComponent("IconUserImage")!
  const _component_JMessageArticlePanelBody = _resolveComponent("JMessageArticlePanelBody")!
  const _component_ThanksMessagePointSummary = _resolveComponent("ThanksMessagePointSummary")!

  return (_openBlock(), _createElementBlock("a", {
    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.getMessageDetails && _ctx.getMessageDetails(...args)), ["prevent"])),
    class: "p-j-message-article-panel"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_IconUserImage, { size: 40 }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _ctx.icon,
              alt: ""
            }, null, 8, _hoisted_3)
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_JMessageArticlePanelBody, {
        "detail-data": _ctx.detailData,
        "unread-count-is-exists": _ctx.unreadCountIsExists
      }, null, 8, ["detail-data", "unread-count-is-exists"]),
      (_ctx.pointIsExists)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_ThanksMessagePointSummary, {
              "gift-points": _ctx.point.giftPoints,
              "received-points": _ctx.point.receivedPoints,
              date: _ctx.messageArticleDetail.date,
              "unread-count": _ctx.messageArticleDetail.unread_count
            }, null, 8, ["gift-points", "received-points", "date", "unread-count"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}